module.exports = __webpack_public_path__ + "2c0f658f3f7c94d99706854d7c3b9afe.png";